import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import toastMessageActions from "jd-library/toastMessageActions"
import ProfileImage from "jd-library/ProfileImage"
import InputWithMovingLabel from "jd-library/InputWithMovingLabel"
import SliderWrapper from "jd-library/SliderWrapper"
import historyHandler from "jd-library/historyHandler"
import style from "./add-delivery-boy.scss"
import axios from "axios"
import VerifyMobileNumber from "../verify-mobile-number/VerifyMobileNumber"
import { editDeliveryBoy } from "../utils"
import { getDeliveryBoyList } from "../../../actions/deliveryBoy"
import { useDispatch } from "react-redux"
import imageCompression from 'browser-image-compression';
import config from '../../../../config/config';

function AddDeliveryBoy(props) {
  const dispatch = useDispatch()
  const img_url = props.editData && props.editData.image_url && (props.editData.image_url.indexOf('https://') > -1 || props.editData.image_url.indexOf('http://') > -1) ? props.editData.image_url : '';
  const [imgUrl, updateUrl] = useState(img_url)
  const [otpFlag, setOtpFlag] = useState(false)
  const [innerContaninerStyle, updateInnerContainerStyle] = useState({
    profile: `${style["profile-inner-container"]}`,
    profileImagePadding : imgUrl ? `${style['profile-image-padding']}` : ``
  })

  let listOptions=[
    {
      label: 'Camera / Gallery',
      key: 'changeImage',
      text: 'Camera / Gallery',
      icon: 'icon-cameraNew'
    },
    {
      label: 'Remove Image',
      key: 'removeImage',
      text: 'Remove Image',
      icon: 'icon-trash'
    }

  ]
  const containerRef = useRef() 
  const inputRef = useRef(null)
  const { token, supplierId } = props.session
  const onRemove = () => {
    let dummyInnerClass = { ...innerContaninerStyle }
    uploadImageProgress({ type : "profile", status: "completed" })
    updateUrl("")
    dummyInnerClass.profileImagePadding = ``;
    updateInnerContainerStyle(dummyInnerClass)
  }
  const ImageTypes = {
    profile: {
      sourceName: "staffmemberprofile",
      containerWidth: 450,
      containerHeight: 450,
      filePath: "customerProfile",
    },
  }

  const uploadImageProgress = (options = {}) => {
    let { type, status } = options
    let dummyInnerClass = { ...innerContaninerStyle }
    if (type == "profile") {
      dummyInnerClass.profile =
        status == "start"
          ? dummyInnerClass.profile + " " + style["image-hide"]
          : status == "completed"
          ? dummyInnerClass.profile + " " + style["default-img"]
          : `${style["profile-inner-container"]} `
          dummyInnerClass.profileImagePadding = style['profile-image-padding']  
    }
    updateInnerContainerStyle(dummyInnerClass)
  }

  const onFileUpload = async (e, options = {}) => {
    let fromApp = options.fromApp || false
    let acceptedFileTypes = ["png", "jpg", "jpeg"]
    let { type } = options
    let selectedImage
    let imageType
    if (fromApp) {
      let { response } = options
      if (response.success) {
        selectedImage = response.filename
        imageType = selectedImage.split(".")
        imageType = imageType[1]
        selectedImage = window.location.origin + "/" + selectedImage
      } else {
        uploadImageProgress({ type, status: "completed" })
        return false
      }
    } else {
      selectedImage = e.target.files[0]
      let fileSize = Number((selectedImage.size / (1024 * 1024)).toFixed(2))
      if (fileSize > 25) {
        showErrorToast("Image cannot exceed more than 25MB")
        uploadImageProgress({ type, status: "completed" })
        return false
      }
      imageType = selectedImage.type.split("/")[1]
    }
    if (acceptedFileTypes.indexOf(imageType) == -1) {
      showErrorToast("Only Png,JPG & JPEG supported")
      uploadImageProgress({ type, status: "completed" })
      return false
    }
    const compressionOptions = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    }
    const compressedFile = await imageCompression(selectedImage, compressionOptions);
    let imgSource = ImageTypes[type]
    let imagePostObj = {
      base64Image: "",
      extension: "jpeg",
      originalExtension: imageType,
      sourceId: 231,
      sourceName: imgSource.sourceName,
      uploadToS3: false,
      containerWidth: imgSource.containerWidth,
      containerHeight: imgSource.containerHeight,
    }
    var reader = new FileReader()
    reader.onloadend = function() {
      uploadImageProgress({ type, status: "start" })
      let base64Data = reader.result
      imagePostObj.base64Image = base64Data
      let configHeaders = {
        headers: { "Content-Type": "multipart/form-data" },
      }
      let fileData = new File([compressedFile], compressedFile.name); 
      let imageUploadData = new FormData()
      imageUploadData.append("uploadedImageFile", fileData)
      // for (let key in imagePostObj) {
      //   if (imagePostObj.hasOwnProperty(key)) {
      //     let val = imagePostObj[key]
      //     imageUploadData.append(key, val)
      //   }
      // }
      let imageBasePath = config.hostKey == 'beta' ? `https://betatestingcentral.jdseller.com/betaimages/product`: `https://image1.jdomni.in/product` 
      axios({
        url: `/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId=${supplierId}`,
        method: "POST",
        data: imageUploadData,
        configHeaders,
      })
        .then((data) => {
          updateUrl(
            `${imageBasePath}${data.data.imgURL}`
          )
          dispatch(
            toastMessageActions.showMessage({
              type: "info",
              message: "Image Uploaded Successfully",
            })
          )
          uploadImageProgress({ type, status: "completed" })
        })
        .catch((err) => {
          showErrorToast(err.message)
          uploadImageProgress({ type, status: "completed" })
        })
    }
    reader.readAsDataURL(selectedImage)
  }

  const showErrorToast = (errorMsg, type) => {
    let msg = errorMsg ? errorMsg : "There is an error"
    dispatch(
      toastMessageActions.showMessage({
        type: "info",
        message: msg,
      })
    )
  }

  const MOBILE_REGEX = /^[9876]{1}[0-9]{9}$/
  const [name, setName] = useState(props?.editData?.name || "")
  const [mobile, setMobile] = useState(props?.editData?.mobile || "")

  const [nameError, setNameError] = useState("")
  const [mobileError, setMobileError] = useState("")

  const handleChange = (e, type) => {
    if (type === "name") {
      setName(e.target.value)
      setNameError("")
       const preservdUrl = props?.editData?.image_url
      if (imgUrl == ""){
          updateUrl(preservdUrl)
      }
    } else if (type === "mobile") {
      setMobile(e.target.value)
      setMobileError("")
    }
  }

  const formInputs = [
    {
      label: "Name",
      key: "Name",
      holderClass: "title-inp",
      input: {
        value: name,
        type: "text",
        autoFocus: true,
        maxlength: 100,
        onChange: (e) => {
          let pattern_name = /^[a-zA-Z\s]+$/
          if (e.target.value && !pattern_name.test(e.target.value)) {
            return
          }
          handleChange(e, "name")
        },
        onFocus: (e)=>{
          setTimeout(()=>
            containerRef?.current?.sliderRef?.current?.sliderContentRef?.current?.firstChild?.firstChild.scrollIntoView({
              behavior: "smooth", 
              block: "end"
            }), 
          100);
        }
      },
    },
    {
      label: "Mobile Number",
      key: "mobile",
      holderClass: "title-inp",
      prepend: () => "+91",
      input: {
        className: props.editData && props.editData.mobile ? 'delboy-mob-number-disabled' : 'delboy-mob-number',
        value:
          props.editData && props.editData.mobile
            ? props.editData.mobile
            : mobile,
        type: "tel",
        // disabled: props.editData && props.editData.mobile ? "disabled" : "",
        autoFocus: false,
        maxlength: 10,
        onChange: (e) => {
          let mobpat = /^[9876]{1}[0-9]{0,9}$/
          if (e.target.value && !mobpat.test(e.target.value)) {
            return
          }
          handleChange(e, "mobile")
        },
        onFocus: (e)=>{
          setTimeout(()=>
            containerRef?.current?.sliderRef?.current?.sliderContentRef?.current?.firstChild?.firstChild.scrollIntoView({
              behavior: "smooth", 
              block: "end"
            }), 
          100);
        }
      },
    },
  ]

  const VerifyMobile = async () => {
    if(!name && !mobile){
      setNameError("Please Enter Name")
      setMobileError("Please Enter Mobile Number")
      dispatch(
        toastMessageActions.showMessage({
          type: "info",
          message: "Please Enter Name and Mobile Number",
          duration: 5000,
        })
      )
    }
    if (!name) {
      setNameError("Please Enter Name")
    } else if (!mobile) {
      setMobileError("Please Enter Mobile Number")
      dispatch(
        toastMessageActions.showMessage({
          type: "info",
          message: "Please Enter Mobile Number",
          duration: 5000,
        })
      )
    } else if (!MOBILE_REGEX.test(mobile)) {
      setMobileError("Please Enter a Valid Mobile Number")
      dispatch(
        toastMessageActions.showMessage({
          type: "info",
          message: "Please Enter a Valid Mobile Number",
          duration: 5000,
        })
      )
    } else {
      if (props?.editData?.mobile) {
        let docid =
          props.editData && props.editData.docid ? props.editData.docid : ""
        let res = await editDeliveryBoy({
          token,
          name,
          mobile,
          imageurl: imgUrl || "",
        })
        dispatch(
          toastMessageActions.showMessage({
            type: "info",
            message: res?.data?.errors?.msg || res?.data?.results?.msg || "",
            duration: 5000,
          })
        )
        if (res.data && res.data.errors && !res.data.errors.code) {
          getDeliveryBoyList(dispatch, props.session.token)
          props.showAddDeliveryBoy(props.tab.prev, "")
        } else {
          console.log(res.data)
        }
      } else {
        setOtpFlag(true)
      }
    }
  }

  const otpSetFlag = (type) => {
    if (type === "success") {
      if (!props?.fromOrders) {
        getDeliveryBoyList(dispatch, props.session.token)
        props.showAddDeliveryBoy(props.tab.prev, "")
        return false
      } else {
        historyHandler.closeCurrent()
        props.closeAddDeliveryBoySlider && props.closeAddDeliveryBoySlider()
      }
    }
    setOtpFlag(false)
  }

  if (otpFlag) {
    return (
      <VerifyMobileNumber
        {...props}
        otpSetFlag={otpSetFlag}
        mobileNumber={mobile}
        name={name}
        imageurl={imgUrl}
      />
    )
  } else {
    return (
      <>
        <SliderWrapper
          sliderClassName={"add-delivery-boy-slider"}
          ref={containerRef}
          header={{
            heading:
              props.editData && props.editData.mobile
                ? "Edit Delivery Boy"
                : "Add Delivery Boy",
          }}
          footer={{
            className: 'verify-btn',
            btnProps: [
              {
                children: "Continue",
                onClick: () => {
                  VerifyMobile()
                },
              },
            ],
          }}
          // slider={{
          //   slideDirection: 'right',
          //   showOverlay: true,
          //   disableAnimation: false
          // }}
          onHidden={() => {
            props?.fromOrders
              ? props.closeAddDeliveryBoySlider && props.closeAddDeliveryBoySlider()
              : props.showAddDeliveryBoy(props.tab.prev, "")
          }}
        >
          <div className={style["add-delivery-boy"]}>
            <div className={style["profile-container"]} ref={inputRef}>
              <ProfileImage
                imageUrl={`https://image1.jdomni.in/jdomni_email/Image_Pasted_at_2020-7-16_14-38_2007161749.png`}
                variant="profileImage"
                btnProps={{ icon: "icon-cameraNew" }}
                styleClasses={{
                  outerContainer: "background-outer-container",
                  conatinerClass: "background-inner-container",
                  editBtnContainerClass: "background-edit-btn-container",
                  editBtnClass: "edit-background-btn",
                }}
              />
              <ProfileImage
                imageUrl={
                  imgUrl ||
                  `https://image1.jdomni.in/jdomni_email/user_1903081501.png`
                }
                listOptions={listOptions}
                btnProps={{ icon: "icon-cameraNew" }}
                onRemove={onRemove}
                onFileUpload={(e, options) => {
                  onFileUpload(e, {
                    type: "profile",
                  })
                }}
                styleClasses={{
                  imageHolder: "profile-image-holder",
                  outerContainer: "profile-outer-container",
                  // conatinerClass: "profile-inner-container default-img",
                  conatinerClass: innerContaninerStyle.profile + ' ' + innerContaninerStyle.profileImagePadding,
                  editBtnContainerClass: "profile-edit-btn-container",
                  editBtnClass: "edit-profile-btn",
                }}
                defaultImage="https://image1.jdomni.in/jdomni_email/user_1903081501.png"
              />
            </div>
            <div className={style["add-delivery-form"]}>
              {formInputs.map((inputObj, index) => (
                <InputWithMovingLabel
                  {...inputObj}
                  errorMessage={
                    inputObj.key === "mobile" ? mobileError : nameError
                  }
                />
              ))}
            </div>
          </div>
        </SliderWrapper>
        {/*!props?.fromOrders ? <div
          style={{
            backgroundImage:
              'url("https://image1.jdomni.in/jdomni_email/Jdbusinessbg_2207071808.png")',
            marginLeft: "80px",
            height: "500px",
            backgroundRepeat: "no-repeat",
          }}
        ></div>:null*/}
      </>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    isMobile: state.library.deviceData.isMobile,
    session: state.session,
  }
}

export default connect(mapStateToProps, {
  showToastMessage: (payload) => {
    return (dispatch) => {
      dispatch(toastMessageActions.showMessage(payload))
    }
  },
})(AddDeliveryBoy)
